// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wcc-widget{font-family:\"Roboto\",sans-serif}.community-widget-cover{position:absolute;top:0;right:0;bottom:0;left:0;display:none}.community-widget__settings{display:flex;align-items:center;width:100%}", ""]);
// Exports
module.exports = exports;
